import { createSlice } from '@reduxjs/toolkit'

const height = '40px'

export const draweLeft = createSlice({
  name: 'drawerLeft',
  initialState: {
    open: false,
    drawerWidth: 200,
    drawerHeight: height,
    drawerWidthMin: '40px',
    contentBox: `calc(100vh - ${height})`,
  },
  reducers: {
    show: (state, action) => {
      state.open = action.payload
    },
  },
})

export const { show } = draweLeft.actions
export default draweLeft.reducer
